import { createApp } from 'vue';
import store from './store/store';
import TrailOverviewMap from './TrailOverviewMap.vue';
import axiosClient from '../../utils/helpers/axios_client';
import 'mapbox-gl/dist/mapbox-gl.css';
import emitter from "../../utils/bus";

// Type augmentation for window properties (keep if needed, but consider alternatives)
declare global {
  interface Window {
    vue: any; // Consider removing or refining type if Vue instance isn't directly needed globally
    map: mapboxgl.Map;
    geoLocate: mapboxgl.GeolocateControl;
    mapReady: Function;
    // Add other custom window properties if they exist (like user, bus, onBoardingVue etc.)
    user: any; // Define a proper type if possible
    bus: any; // Define a proper type for your event bus
    onBoardingVue: any; // Define type
    showMapModalForTrail: (trailId: string | number) => void; // Define type
    printingUrl: string; // Define type
    trail_overview_map_vue: any; // Keep for the check, though the instance itself is different
  }
}

const mountElement = document.querySelector('#trail_overview_map');
if (mountElement && window.trail_overview_map_vue == null) {

  // --- Initial setup logic moved from beforeCreate ---
  // Dispatch initial store action before creating the app

  // Setup global event listener (consider component-level or service-level listeners instead)
  emitter.on('user:updated', async () => {
    try {
      const response = await axiosClient.get('/user/current');
      const userData = response.data;
      // Update store state instead of just global window property
      // store.commit('user/setUser', userData); // Example mutation
      window.user = userData; // Keep global if legacy parts depend on it heavily
      console.log('User updated via bus:', userData);
    } catch (error) {
      console.error("Error fetching current user:", error);
    }
  });
  // --- End of moved setup logic ---

  // Create the Vue 3 app instance
  const app = createApp(TrailOverviewMap);
  app.use(store);
  app.mount('#trail_overview_map');

  store.dispatch('trailOverviewMap/initialiseStore');

} else if (mountElement) {
  console.log("Trail overview map already initialized.");
} else {
  console.log("Trail overview map mount element not found.");
}
